module.exports = __webpack_public_path__ + "static/media/mai1.7ccf782d.jpg";